import React from 'react';
import { Circle, G, Line, Path, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { DT } from '../tokens';

/** Cost = (BTU/h · H) / (HHV · η) · $/unit — boiler + runtime clock + $ stack. */
export function DiagramBoilerOperatingCost() {
  const bx = 125, by = 80, bw = 110, bh = 105;

  return (
    <DiagramCanvas>
      {/* Boiler */}
      <Rect x={bx} y={by} width={bw} height={bh} rx="8" fill={DT.fill} stroke={DT.stroke} strokeWidth="1.8" />
      {[0, 1, 2].map(i => (
        <Line key={i} x1={bx + 10} y1={by + 26 + i * 20} x2={bx + bw - 10} y2={by + 26 + i * 20}
          stroke={DT.stroke} strokeWidth="0.6" opacity={0.35} strokeDasharray="5,3" />
      ))}
      <Path d={`M${bx + bw / 2 - 10},${by + bh - 16} Q${bx + bw / 2},${by + bh - 42} ${bx + bw / 2 + 10},${by + bh - 16} Z`}
        fill="#FF6B1A" opacity={0.55} />
      <SvgText x={bx + bw / 2} y={by + bh - 4} fill={DT.desc} fontSize="8" fontFamily={DT.mono} textAnchor="middle">BOILER</SvgText>
      <Rect x={bx + bw / 2 - 8} y={40} width={16} height={by - 40} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.2" />

      {/* Runtime clock (left) */}
      <Circle cx={55} cy={130} r={22} fill={DT.fill} stroke={DT.leader} strokeWidth="1.6" />
      {[0, 90, 180, 270].map(d => {
        const r = d * Math.PI / 180;
        return <Line key={d} x1={55 + 18 * Math.cos(r)} y1={130 + 18 * Math.sin(r)}
          x2={55 + 22 * Math.cos(r)} y2={130 + 22 * Math.sin(r)} stroke={DT.leader} strokeWidth="1" />;
      })}
      <Line x1={55} y1={130} x2={55} y2={116} stroke={DT.varColor} strokeWidth="1.6" />
      <Line x1={55} y1={130} x2={68} y2={130} stroke={DT.varColor} strokeWidth="1.2" />
      <Circle cx={55} cy={130} r={2} fill={DT.varColor} />
      <SvgText x={55} y={168} fill={DT.leader} fontSize="8" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">runtime H</SvgText>

      {/* $ stack (right) */}
      <Rect x={270} y={95} width={62} height={80} rx="4" fill={DT.fill} stroke={DT.varColor} strokeWidth="1.6" />
      <SvgText x={301} y={122} fill={DT.varColor} fontSize="22" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">$</SvgText>
      {/* Stacked bills */}
      {[0, 1, 2].map(i => (
        <Rect key={i} x={280} y={140 + i * 8} width={42} height={5} fill={DT.varColor} opacity={0.5 - i * 0.1} />
      ))}
      <SvgText x={301} y={185} fill={DT.desc} fontSize="8" fontFamily={DT.mono} textAnchor="middle">cost</SvgText>

      {/* Connections */}
      <Line x1={77} y1={130} x2={bx} y2={130} stroke={DT.leader} strokeWidth="1" strokeDasharray="3,2" />
      <Line x1={bx + bw} y1={130} x2={270} y2={130} stroke={DT.varColor} strokeWidth="1.2" strokeDasharray="3,2" />
      <Polygon points={`268,130 260,126 260,134`} fill={DT.varColor} />

      {/* HHV + $/unit pills */}
      <Rect x={bx + 12} y={by + 8} width={86} height={14} fill="rgba(0,0,0,0.5)" stroke={DT.varColor} strokeWidth="0.5" />
      <SvgText x={bx + 55} y={by + 18} fill={DT.varColor} fontSize="8" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">HHV · η</SvgText>
      <Rect x={200} y={42} width={72} height={16} fill="rgba(0,0,0,0.5)" stroke={DT.varColor} strokeWidth="0.5" />
      <SvgText x={236} y={53} fill={DT.varColor} fontSize="8" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">$/therm or MCF</SvgText>

      {/* Labels */}
      <LeaderLine x1={bx + bw / 2} y1={by} x2={170} y2={35} varName="BTU/h" desc="firing rate" anchor="middle" />
      <LeaderLine x1={55} y1={152} x2={20} y2={215} varName="H" desc="hours run" anchor="start" />
      <LeaderLine x1={236} y1={58} x2={335} y2={60} varName="$/unit" desc="fuel price" anchor="end" />
      <LeaderLine x1={301} y1={175} x2={330} y2={215} varName="Cost" desc="$ total" anchor="end" />

      <FormulaTag formula="Cost = (BTU/h · H) / (HHV · η) · $/unit" />
    </DiagramCanvas>
  );
}
